import { t } from '@avalara/bat-apps-shared/i18n';

import { SIcon } from '@avalara/skylab-sdk/react';

import styled from 'styled-components';
import BuyButton from '../buy-button';
import { FormContainer } from '../styled/forms';

const nextSteps = [
  'Your free trial starts immediately after you sign up',
  'Limited to 5 orders and 5 invoices per minute, with a daily cap of 1,000 total transactions',
  'No-hassle trial ends automatically after 90 days',
];

const LightGreenIcon = styled(SIcon)`
  color: var(--color-feedback-text-success);
`;

const FreeTrialReview = () => (
  <FormContainer>
    <h1 className='pad-bottom-md'>{t('client.headings.review-your-order')}</h1>
    <p>
      {t('client.general.your-product-is-almost-ready', { productName: t('client.general.90-day-avatax-free-trial') })}
    </p>

    <p className='font-bold margin-top-sm pad-bottom-sm'>{t('client.general.what-you-get')}</p>
    {nextSteps.map((step) => (
      <p key={step}>
        <LightGreenIcon name='check' className='margin-right-sm' />
        {step}
      </p>
    ))}

    <p className='margin-top-md'>{t('client.general.this-trial-is-for-new-customers-only-and-is-not-renewable-up')}</p>

    <BuyButton />
  </FormContainer>
);

export default FreeTrialReview;
